import React, { useEffect, useRef } from 'react';

export interface TrackerJsProps {
  customJs?: string;
  location?: 'body' | 'head';
  trackerName?: string;
  forceHeadOnly?: boolean;
}

export const TrackerJs: React.VFC<TrackerJsProps> = ({
  customJs,
  location,
  trackerName,
  forceHeadOnly,
}) => {
  const customJsDiv = useRef<HTMLDivElement>(null);
  const newTags = useRef<HTMLElement[]>([]);

  useEffect(() => {
    const div = document.createElement('div');

    if (!customJs || !customJsDiv.current) {
      return undefined;
    }

    div.innerHTML = customJs;

    div.childNodes.forEach(node => {
      // Can't append and iterate at same time

      if (node.nodeName === 'SCRIPT') {
        const newScript = document.createElement('script');
        newScript.textContent = node.textContent;
        if (trackerName && trackerName.trim().length > 0) {
          newScript.setAttribute('data-tracker-name', trackerName);
        }

        const attributes = (node as HTMLScriptElement).getAttributeNames();

        attributes.forEach(attribute => {
          const value = (node as HTMLScriptElement).getAttribute(attribute);

          if (value) {
            newScript.setAttribute(attribute, value);
          }
        });

        newTags.current.push(newScript);
        return;
      }
      newTags.current.push(node as HTMLElement);
    });

    newTags.current.forEach(node => {
      if (location === 'head') document.head.appendChild(node);
      if (location === 'body') document.body.appendChild(node);
    });

    if (forceHeadOnly) {
      customJsDiv.current.innerHTML = '';
    } else {
      customJsDiv.current.innerHTML = div.innerHTML;
    }

    const stableTags = newTags.current;

    return () => {
      stableTags.forEach(node => {
        node.remove();
      });
    };
  }, [customJs, location, trackerName, forceHeadOnly]);

  return <div ref={customJsDiv} />;
};
